import { render, staticRenderFns } from "./MaxLengthInput.vue?vue&type=template&id=0637bbaf&scoped=true"
import script from "./MaxLengthInput.vue?vue&type=script&lang=js"
export * from "./MaxLengthInput.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthInput.vue?vue&type=style&index=0&id=0637bbaf&prod&lang=scss&scoped=true"
import style1 from "./MaxLengthInput.vue?vue&type=style&index=1&id=0637bbaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637bbaf",
  null
  
)

export default component.exports